import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is Generative AI?",
    answer: `<p>Generative AI is a type of artificial intelligence that can create new content, such as text, images, or music, by learning patterns from existing data. It uses models like GPT-4 to generate human-like responses and creative outputs.</p>`,
  },
  {
    question: "What is the Difference Between OpenAI and Generative AI?",
    answer: `<p>OpenAI is a research organization that develops advanced AI technologies, including generative AI models. Generative AI refers to the technology itself, capable of creating new content based on learned patterns.</p>`,
  },
  {
    question: "How to Build a Generative AI Solution?",
    answer: `<p>To build a generative AI solution, start by defining your use case and gathering relevant data. Choose an appropriate AI model, train it with your data, and fine-tune it for accuracy. Deploy the model using a scalable infrastructure, and continuously monitor and improve its performance.</p>`,
  },
  {
    question: "What Problem Does Generative AI Solve?",
    answer: `<p>Generative AI solves problems related to content creation, automation, and data augmentation. It can generate high-quality text, images, and other content, automate repetitive tasks, and enhance data sets for improved machine learning models.</p>`,
  },
  {
    question: "How Secure is Generative AI?",
    answer: `<p>Generative AI can be secure if proper measures are taken, such as data encryption, access control, and regular security audits. Ensuring ethical use and monitoring for biases are also crucial for maintaining security and trust.</p>`,
  },
  {
    question: "Can Generative AI Be Customized for Specific Industries?",
    answer: `<p>Yes, generative AI can be tailored to specific industries by training it on domain-specific data. This customization improves the model's relevance and accuracy, making it more effective for industry-specific applications like healthcare, finance, or marketing.</p>`,
  },
  {
    question: "What are the Costs Associated with Implementing Generative AI?",
    answer: `<p>The costs of implementing generative AI include data acquisition, model training, infrastructure, and ongoing maintenance. Initial setup can be expensive, but long-term benefits often justify the investment through increased efficiency and innovation.</p>`,
  },
  {
    question: "How Do You Ensure Ethical Use of Generative AI?",
    answer: `<p>Ethical use of generative AI is ensured by implementing strict guidelines, conducting regular audits, and promoting transparency. It's essential to address biases, ensure data privacy, and adhere to ethical standards to build trust and accountability.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Generative AI Solutions FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
